<template>
  <div id="app" >
    <div v-if="menuKey == 1" class="floatWindow">
      祥瑞金业欢迎您！您现在访问的是香港网站。投资需谨慎。
      <img @click="closer" src="../static/index/closer.png" alt="">
    </div>
    <layout-vue v-if="this.control == false" @getKey="getKey"></layout-vue>
    <router-view @controlShow="controlShow" />
    <contactusVue v-if="this.control == false"></contactusVue>
  </div>
</template>

<script>
import LayoutVue from "./components/Layout.vue";
import ContactusVue from "./components/Contactus.vue";
import { getUserIp } from '../api/info';

export default {
  name: 'App',
  components:{
    LayoutVue,
    ContactusVue
  },
  data(){
    return{
      menuKey:1,
      control:true,
    }
  },
  created(){
    // this.getIp();
    console.log(this.control);
  },
  methods:{
    getKey(key){
      this.menuKey = key;
    },
    controlShow(key){
      this.control = key;
    },
    closer(){
      this.menuKey = !this.menuKey;
    },
    getIp() {
      getUserIp().then(res => {
        if (res.code == 200) {
          let ipdata = res.ipdata;

          if (ipdata.info1.indexOf('香') != -1 || ipdata.info2.indexOf('香') != -1 || ipdata.info3.indexOf('香') != -1) {
            this.closer();
            
            this.$router.push({
              name: '404'
            });
          };
        };
      });
    }
  }
}
</script>

<style lang="less">
html,
body,
#app {
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  .floatWindow{
    width: 100%;
    min-width: 1130px;
    margin: 0 auto;
    font-size: 13px;
    text-align: center;
    padding: 8px 0px;
    color: #ff9b1c;
    background-color: rgba(240, 215, 132, 0.4);
    img{
      cursor: pointer;
    }
  }
}
ul{
  padding-left: 0;
  margin: 0 auto;
}
ul li{
  padding-left: 0px;
  list-style: none;
}
a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}
</style>
